import React, { JSX } from 'react';
import { Select } from '@/components';
import { OptionProps } from '@/components/Select';
import Payment from '@/model/Payment';
import { CardCheckout } from '../types';

interface StateProps {
  payment: Payment;
  totalValue: number;
  card: CardCheckout;
}

interface DispatchProps {
  toCurrency: (value: number) => string;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => void;
}

type Props = StateProps & DispatchProps;

export const CreditCardC6PaymentRequestContent: React.FC<Props> = ({
  payment,
  totalValue,
  toCurrency,
  onChange,
  card,
}): JSX.Element => {
  const options: OptionProps[] = [];

  if (payment && payment.fees && payment.fees.installments) {
    if (totalValue > 0) {
      const newTotalValue = Number(totalValue) + Number(totalValue * payment.fees.credit) / 100;
      const feeCreditCard = Number(payment.fees.fee) / 100;
      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= payment.fees.installments; i++) {
        let value: number;
        if (i === 1) {
          value = newTotalValue + 0;
        } else {
          value = newTotalValue * (1 + feeCreditCard) ** (i - 1);
        }
        const option: OptionProps = {
          value: i,
          label: `${i} X ${toCurrency(value / i)}`,
        };
        options.push(option);
      }
    }
  }
  return (
    <div className="w-full md:w-[411px] mt-[14px]">
      <div className="flex flex-col justify-between">
        <div className="space-y-5 ">
          <div>
            <div className="mb-[20px]">
              <div className="block mt-[20px] mb-[20px]">
                <div className="mb-[20px]">
                  <Select
                    name="installments"
                    label="Parcelamento"
                    placeholder="Escolha a quantidade de parcelas"
                    className={`appearance-none w-full
              rounded-md text-heading leading-tight focus:outline-none
              focus:shadow-outline text-xs font-dmsans font-normal`}
                    maxLength={18}
                    value={card.installments}
                    onChange={e => onChange(e)}
                    options={options}
                    error={card.installmentsError}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
